// AUTO-GENERATED by scripts/build-registry.js: study entry for aeronautics/attitude-indicator.
import { mount } from '#engine/lesson-page.js';
import g0 from '../lessons/aeronautics/attitude-indicator/attitude-indicator-errors.js';
import g1 from '../lessons/aeronautics/attitude-indicator/attitude-indicator.js';

mount([g0, g1]);
